/**
 * @ngdoc controllers
 * @memberof mercury.modules.qa.bepoz
 * @name QaBepozOperatorSummaryCtrl
 * @description Report that replicates the Operator Summary report in the Bepoz backoffice
 */
angular.module('mercury.modules.qa.bepoz.operatorsummary')
.controller('QaBepozOperatorSummaryCtrl', ["OperatorSummary", "reporttime", "$scope", "title", function(OperatorSummary, reporttime, $scope, title) {
  reporttime.setAllowedTypes(['day', 'week', 'month', 'year', 'yesterday', 'custom']);
  reporttime.defaultType = 'day';
  reporttime.restrictToCurrent = true;

  title.set('Operator Summary');

  $scope.activeGroupId = null;
  $scope.startTime = reporttime.start();
  $scope.endTime = reporttime.end();

  $scope.loading = OperatorSummary.getOperatorGroups();
  $scope.loading.then(function(groups) {
    $scope.groups = groups;

    $scope.groupSelected(null);
  });

  $scope.groupSelected = function(id) {
    $scope.activeGroupId = id;

    $scope.operatorsLoading = OperatorSummary.getOperatorGroupSales(reporttime.start(), reporttime.end(), id);
    $scope.operatorsLoading.then(function(operators) {
      $scope.operators = operators;
    });
  };
}]);
